import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to the element matching the current URL hash, re-running whenever
 * the hash changes (e.g. clicking a same-page nav link) or once data loads. */
export function useHashScroll(ready) {
  const { hash } = useLocation();
  useEffect(() => {
    if (!ready || !hash) return;
    const id = hash.slice(1);
    const timer = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
    return () => clearTimeout(timer);
  }, [ready, hash]);
}
